globalThis.searchFilterAjax = (function () {

  function searchFilterAjax($html, options) {
    this.config                   = $.extend({}, options);
    this.$html                    = $html;
    this.$input                   = this.$html.find($(".ajax-search-input"))
    this.config.targetContainer   = this.$input.data("search-target");
    this.config.targetAjaxUrl     = this.$input.data("ajax-url");
    this.init();
  }

  searchFilterAjax.prototype = {
    init: function(){
      var me = this;

      me.config.searchBar        = $("#" + me.config.targetContainer + "-ajax-search");
      me.config.resultsContainer = $("#" + me.config.targetContainer + "-results-container");
      me.config.emptyResults     = $("#" + me.config.targetContainer + "-empty-results");
      me.config.showAllResults   = $("#" + me.config.targetContainer + "-all-results");
      me.initSearchBar();
      me.initEmptyResults();
    },
    initSearchBar: function(){
      var me = this;
      var config = me.config;
      var inputDelay = 0;

      config.searchBar.on("input", function(){
        $searchBar = $(this);
        if ($searchBar.val() != "") {
          clearTimeout(inputDelay);
          inputDelay = setTimeout(function() {
            me.searchFromInput($searchBar.val());
          }, 500);
        } else {
          config.resultsContainer.hide();
          config.emptyResults.hide();
          clearTimeout(inputDelay);
        }
      })
    },
    initEmptyResults: function(){
      var me = this;
      var config = me.config;

      config.showAllResults.on("click", function(){
        me.searchFromInput("");
      })
    },
    searchFromInput: function(search){
      var config = this.config;

      $.ajax({
        method: "GET",
        url: config.targetAjaxUrl + "?search=" + search,
        dataType: "JSON",
        success: function(data) {
          if(data.response == 1 && data.views) {
            config.resultsContainer.show().html(data.views.search_results);
            config.emptyResults.hide();
          } else if (data.response == 1 && data.message){
            config.resultsContainer.hide();
            config.emptyResults.show().html(data.message.empty_result);
          }
        }
      });
    }
  }

  return searchFilterAjax
}())

